import GenerateAPI from '../generate.js'

const config = {
    login: {
        url: '/client/auth/login',
    },
    netIdLogin:{
        url: '/client/auth/netId/login',
        apiType: 'check',
    },
    commssoLogin:{
        url: '/client/auth/commsso/login',
        apiType: 'check',
    },
    logout: {
        url: '/shiro/loginout',
    },
    info: {
        url: '/client/person/get',
    },
    update: {
        url: '/client/person/update',
    },
    shiro: {
        url: '/shiro/get/random/image',
    },
    register: {
        url: '/client/auth/register',
    },
    userInfo: {
        url: '/client/person/get',
        apiType: 'check',
    },
    userDetail: {
        url: '/client/person/get',
        apiType: 'check',
    },
    loginState: {
        url: '/shiro/login/state',
        apiType: 'check',
    },
    cardType: {
        url: '/shiro/credentials/type/list',
        apiType: 'check',
    },
    loginCardType:{
        url: '/client/combo/credential/type/list',
        apiType: 'check',
    },
    registerCardType:{
        url: '/client/combo/reg/credential/type/list',
        apiType: 'check',
    },
    defaultTitle: {
        url: '/base/title/getdefaultTitleByCode',
        apiType: 'check',
    },
    userTitle: {
        url: '/client/person/get/use/default/title',
        apiType: 'check',
    },
    getSysCode: {
		url: '/getSysCode',
		apiType: 'check',
	},
    rsaKey: {
        url: '/client/person/get/rsapublickey',
        apiType: 'check',
    }
    ,
    noticeList: {
        url: '/client/person/notice/list',
        apiType: 'check',
    }
    ,
    noticeDetail: {
        url: '/client/person/notice/get',
        apiType: 'check',
    },
    wexinConfig:{
        url:'/client/person/wx/config',
        apiType: 'check',
    },
    weixinIndentify:{
        url:'/client/person/wx/identify',
    },
    weixinIndentityVerify:{
        url:'/client/person/wx/identityVerify',
        timeout:5000,
    },
    bankNumCheckInIdentify:{
        url:'/client/person/wx/bankNumCheckInIdentify',
        apiType: 'check',
    },
    bankNumCheckInIdentifyVerify:{
        url:'/client/person/wx/bankNumCheckInIdentifyVerify',
        timeout:5000,
        apiType: 'check',
    },
    bankNumCheckIn:{
        url:'/client/person/wx/bankNumCheckIn',
        apiType: 'check',
    },
    bankNumCheckInRegist:{
        url:'/client/person/wx/bankNumCheckInRegist',
    }
}

const apiLoginPage = GenerateAPI.generate(config)

export default apiLoginPage
